module.exports = __webpack_public_path__ + "img/4.5fa98e42.png";